/**
 * Solo game simulation — a thin wrapper over the shared `RoundEngine`
 * (`src/game-core.ts`) so the offline practice mode and the authoritative
 * server room run the exact same per-tick rules. All eating/scoring/spawn
 * logic lives in the core; this only adapts the engine to the `RoundState`
 * shape the solo renderer/HUD expect.
 */

import type { PlayerRoundState, RoundState, MouthSample, SimEvent } from "./types.js";
import { RoundEngine } from "./types.js";

export class GameSim {
  private readonly engine = new RoundEngine();

  start(seed: number, durationMs: number, playerIds: string[]): void {
    this.engine.start(seed, durationMs, playerIds);
  }

  applyMouth(playerId: string, s: MouthSample): void {
    this.engine.applyMouth(playerId, s);
  }

  get state(): RoundState {
    const players: Record<string, PlayerRoundState> = {};
    for (const id of this.engine.ids()) {
      players[id] = { score: this.engine.scoreOf(id), burnUntil: this.engine.burnUntilOf(id) };
    }
    return {
      running: this.engine.running,
      elapsed: this.engine.elapsed,
      duration: this.engine.duration,
      foods: this.engine.foods,
      players,
    };
  }

  tick(): SimEvent[] {
    return this.engine.tick();
  }
}
